module.exports = __webpack_public_path__ + "static/fire-946cdd1969b0586281361b3e9bba8b2b.png";